import { i18next } from '@yola/ws-sdk';

const pathRegexp = /^\/(?!ws\/)([^\s?^/#]+\/?)+[^/]$/;

const createDownloadCustomPathValidator = () => (value) => {
  if (!value) {
    return i18next.t('Invalid URL. Please, check the URL and try again');
  }

  if (!value.startsWith('/')) {
    return i18next.t('The "/" is missing at the beginning');
  }

  if (value.endsWith('/')) {
    return i18next.t('URL can\'t end with "/". Please remove it');
  }

  if (!pathRegexp.test(value)) {
    return i18next.t('Invalid URL. Please, check the URL and try again');
  }

  return null;
};

export default createDownloadCustomPathValidator;
